import imageDe from '../images/de/uploader-oneTouchUltraMini-3.png';
import imageEn from '../images/en/uploader-oneTouchUltraMini-3.png';
import imageEs from '../images/es/uploader-oneTouchUltraMini-3.png';
import imageFi from '../images/fi/uploader-oneTouchUltraMini-3.png';
import imageFr from '../images/fr/uploader-oneTouchUltraMini-3.png';
import imageIt from '../images/it/uploader-oneTouchUltraMini-3.png';
import imageNo from '../images/no/uploader-oneTouchUltraMini-3.png';
import imageSv from '../images/sv/uploader-oneTouchUltraMini-3.png';

export const uploaderUploadingImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
